module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements.htm"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/list_of_abbreviations.htm"
    }
  }, [_c('i', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction_facing_multiple_challenges.htm"
    }
  }, [_vm._v("Introduction: Facing Multiple Challenges")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/1_the_making_of_todays_china.htm"
    }
  }, [_vm._v("1 The Making of Today’s China")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/2_the_broken_economic_model.htm"
    }
  }, [_vm._v("2 The Broken Economic Model")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/3_the_elusive_knowledge_economy.htm"
    }
  }, [_vm._v("3 The Elusive Knowledge Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/4_finance.htm"
    }
  }, [_vm._v("4 Finance")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/5_social_welfare_missing_umbrella.htm"
    }
  }, [_vm._v("5 Social Welfare: Missing Umbrella")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/6_the_environment.htm"
    }
  }, [_vm._v("6 The Environment")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/7_threats_to_social_stability.htm"
    }
  }, [_vm._v("7 Threats to Social Stability")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/8_threats_to_civil_stability.htm"
    }
  }, [_vm._v("8 Threats to Civil Stability")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/9_identity_future_of_state_and_party.htm"
    }
  }, [_vm._v("9 Identity: Future of State and Party")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/10_america_and_china_common_interests_mutual_antagonisms.htm"
    }
  }, [_vm._v("10 America and China: Common Interests, Mutual Antagonisms")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/11_great_power_relationships.htm"
    }
  }, [_vm._v("11 Great Power Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/12_central_asia.htm"
    }
  }, [_vm._v("12 Central Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/13_undeclared_war_in_the_fourth_dimension.htm"
    }
  }, [_vm._v("13 Undeclared War in the Fourth Dimension?")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/14_nervous_neighbours.htm"
    }
  }, [_vm._v("14 Nervous Neighbours")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/15_china_in_the_world.htm"
    }
  }, [_vm._v("15 China in the World")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/16_outcomes.htm"
    }
  }, [_vm._v("16 Outcomes")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0